import "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

//import plugins
import {
  MaxLength as maxlength,
  Toastr as toastr,
  Mask as mask,
} from "js/shared/plugins/Plugins";

//import core
import core from "js/site/shared/Core";

//import entity
import HumanResources from "js/model/humanresources/HumanResources";

const promises = [
  new Promise(() => core.init()),
  new Promise(() => maxlength()),
  new Promise(() => mask(".masked")),
];

Promise.all(promises).then(
  setTimeout(() => {
    loadPlugins();
    $("form").last().find("*").filter(":input:visible:first").focus();
  }, 250)
);

function loadPlugins() {
  console.log("Plugins loaded");

  $(window).scroll(function () {
    const pageHeading = $("section.page-heading");
    const shrinkIt = pageHeading.height();
    const scroll = $(window).scrollTop();

    if (scroll >= shrinkIt) {
      pageHeading.addClass("fixed-content-title");
    } else {
      pageHeading.removeClass("fixed-content-title");
    }
  });

  const openShareWindowButtons = document.querySelectorAll(
    "a.open-share-window"
  );
  const shareButtons = document.querySelectorAll("a.share-button");

  const url = window.location.href;
  const pageTitle = document.getElementById("page-title").value;

  let shareOnTwitter = `https://twitter.com/share?url=${url}&text=${pageTitle}&via=goztepe`;
  let shareOnFacebook = `https://www.facebook.com/sharer/sharer.php?u=${url}&title=${pageTitle}`;
  let shareOnWhatsapp = `https://api.whatsapp.com/send?text=${url}`;
  let shareOnEmail = `mailto:?subject=${pageTitle}&amp;body=Göztepe resmi sitesinde okumanı istediğim bir içerik buldum.%0D%0D${url}`;

  shareButtons.forEach((btn) => {
    if (btn.classList.contains("share-twitter"))
      btn.dataset.url = shareOnTwitter;

    if (btn.classList.contains("share-facebook"))
      btn.dataset.url = shareOnFacebook;

    if (btn.classList.contains("share-whatsapp")) btn.href = shareOnWhatsapp;

    if (btn.classList.contains("share-mail")) btn.href = shareOnEmail;
  });

  openShareWindowButtons.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      const windowWidth = 650,
        windowHeight = 450,
        shareUrl = this.dataset.url,
        shareTitle = e.target.title;

      window.open(
        shareUrl,
        shareTitle,
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${windowWidth},height=${windowHeight},top=${
          (screen.height - windowHeight) / 2
        },left=${(screen.width - windowWidth) / 2}`
      );
    });
  });

  const btnIAgree = document.querySelector("button#btn-i-aggree");
  const btnSendMessage = document.querySelector("button#send-message");
  const chkIAgree = document.querySelector("input#i-aggree");
  const fileUpload = document.querySelector("input#file");
  const labelUpload = document.querySelector("label.custom-file-label");
  const loader = document.querySelector("div.loader");
  const captcha = document.querySelector("div.g-recaptcha > div");
  const captchaResponse = document.querySelector("#response");
  const form = document.querySelector("#hr-form");

  $("#personel-data-protection-law-agreement").on(
    "shown.bs.modal",
    function () {
      btnIAgree.disabled = false;
      btnSendMessage.disabled = false;
    }
  );

  fileUpload.addEventListener("change", (e) => {
    e.preventDefault();
    const fileName = fileUpload.files[0].name;
    labelUpload.innerText = fileName;
  });

  btnIAgree.addEventListener("click", (e) => {
    e.preventDefault();
    chkIAgree.checked = true;
  });

  btnSendMessage.addEventListener("click", (e) => {
    e.preventDefault();
    loader.classList.toggle("d-none");
    const verificationResponse = grecaptcha.getResponse();
    const model = new HumanResources();
    const state = model.validate();
    let timeout = 100;

    if (state.errors != null || !verificationResponse.length > 0) {
      for (let key in state.errors) {
        createError(key);
        setTimeout(() => {
          toastr("error", state.errors[key][0]);
        }, timeout);
        timeout += 500;
      }

      if (!verificationResponse.length > 0) {
        toastr("error", "Robot olmadığınızı doğrulamanız gerekmektedir");
        captcha.classList.toggle("captcha-is-invalid");
      }

      loader.classList.toggle("d-none");
    } else {
      captchaResponse.value = verificationResponse;

      const formData = new FormData(form);
      const xhr = new XMLHttpRequest();
      xhr.open("POST", "/api/sendresume");
      xhr.responseType = "json";
      xhr.onload = () => {
        if (xhr.status == 200) {
          const response = xhr.response;

          const message = response.message;
          const type = !response.error ? "success" : "error";

          if (response.error || response.error != undefined) {
            toastr(type, message);
            console.log("Successfuly send!");
          } else {
            const errors = response.errors;
            Object.keys(errors).forEach((el) => {
              toastr("error", errors[el][0]);
            });
          }

          form.reset();
          model.reset();
          labelUpload.innerText = "Dosya Seçin";
          captcha.classList.remove("captcha-is-invalid");
          loader.classList.toggle("d-none");
        }
      };

      xhr.send(formData);
    }
  });
}

const createError = (elementId) => {
  let element = document.getElementById(elementId);
  element.classList.add("is-invalid");
  if (element.getAttribute("data-target") != null) {
    let target = element.getAttribute("data-target");
    element = document.getElementById(target);
  }
};
